(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("wms", [], factory);
	else if(typeof exports === 'object')
		exports["wms"] = factory();
	else
		root["wms"] = factory();
})(self, function() {
return 